<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <vs-prompt title="Forgot Your Password?" @cancel="val = ''" @accept="validateEmail" :active.sync="showForgotPassword">
      <div class="con-exemple-prompt">
        <span>Enter Your Email Address</span>
        <vs-input v-validate="'required|min:3'" placeholder="enter your email here..."
          vs-placeholder="enter your email here..." v-model="emailRecovery" class="mt-3 w-full" />
      </div>
    </vs-prompt>

    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/ejuice.png" alt="login" class="mx-auto" width="500px" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login <small class="float-right text-warning">v5.2</small></h4>
                  <p>Welcome back, please login to your account.</p>
                </div>

                <div> 
                  <vs-input name="email" icon-no-border icon="icon icon-user" icon-pack="feather"
                    label-placeholder="Email" v-model="email" class="w-full" @keyup.enter="loginUser" />

                  <vs-input type="password" name="password" icon-no-border icon="icon icon-lock" icon-pack="feather"
                    label-placeholder="Password" v-model="password" class="w-full mt-6" @keyup.enter="loginUser" />

                  <div class="flex flex-wrap justify-between my-5">
                    <span style="color: blue; cursor: pointer" @click="showForgotPassword = true">Forgot Password?</span>
                  </div>
                  <!-- <vs-button @click="registerUser" type="border">Register</vs-button> -->
                  <vs-button class="float-right mb-10" @click="loginUser" :disabled="!validateForm">Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";
import { alertMixin } from "../../mixin/alertMixin";
import { helperMixin } from "../../mixin/helperMixin";
import { axiosMixin } from "../../mixin/axiosMixin";
export default {
  mixins: [alertMixin, helperMixin, axiosMixin],
  data() {
    return {
      email: "",
      password: "",
      showForgotPassword: false,
      checkbox_remember_me: false,
      emailRecovery: "",
      recoveryEndpoint: "/sendPasswordRecovery",
    };
  },
  computed: {
    validateForm() {
      return this.email != "" && this.password != "";
    },
  },
  methods: {
    validateEmail() {
      if (this.emailRecovery == "") {
        this.errorAlert("Required", "Your Email Address is required");
        this.showForgotPassword = true;
      } else {
        this.submitPasswordRecovery();
      }
    },
    submitPasswordRecovery() {
      axios({
        method: "post",
        url: this.recoveryEndpoint,
        data: { email: this.emailRecovery },
      })
        .then((response) => {
          if (response.data.status == "success") {
            this.successAlert("Sent", response.data.msg);
          } else {
            this.errorAlert("Failed", response.data.msg);
          }
        })
        .catch((error) => {
          this.decodeErrorFromAxios(error);
        });
    },
    registerUser() {
      this.$router.push("/register").catch(() => { });
    },
    loginUser() {
      this.$store.dispatch("auth/updateProject", {});
      const payload = {
        email: this.email,
        password: this.password,
      };

      axios({
        method: "post",
        url: "/loginUser",
        data: payload,
      })
        .then((response) => {
          this.decodeSuccessFromAxios(response);

          this.$store.dispatch("auth/updateToken", response.data.token);
          this.$store.dispatch("auth/updatePermission", response.data.permissions);

          response.data.data.data.role = this.flattenJsonStringArray(
            response.data.data.data.role,
            "label"
          );
          this.$store.dispatch("auth/updateUserInfo", response.data.data);

          console.log("response.data.settings:", response.data.settings);
          //update the settings
          this.$store.dispatch("auth/updateSystemSettings", response.data.settings);

          console.log("userinfo:", response.data.data.data);

          //getSelectedOnLevelObj
          this.$router.push("/home").catch(() => { });
        })
        .catch((error) => {
          this.decodeErrorFromAxios(error);
        });
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }

    .bg-twitter {
      background-color: #00aaff;
    }

    .bg-google {
      background-color: #4285f4;
    }

    .bg-github {
      background-color: #333;
    }
  }
}
</style>